import type { TerminalEntity } from "src/app/features/Terminal/types/TerminalEntity";
import type { TerminalProfileEntity } from "src/app/features/TerminalProfile/types/TerminalProfileEntity";
import { deepClone } from "../../../core/utils/utilFunctions";

const UPDATE_FIELDS = [
    "terminalType",
    "cardEntryMode",
    "serialProtocol",
    "posIpAddress",
    "posPort",
    "deviceApiToken",
    "abortNeedsRequestId",
    "cloudFlowEnabled",
];

const UPDATE_NESTED_FIELD_PREFIXES = [
    "merchantReferenceNumber1.",
    "merchantReferenceNumber2.",
    "tipHandling.",
    "surchargeAmount.",
    "taxAmount.",
];

export const updateWatchedFieldsUtils = (profile: TerminalProfileEntity, formData: TerminalEntity): TerminalEntity => {
    const newFormData = deepClone(formData);

    // Set field values from terminal profile
    UPDATE_FIELDS.forEach((fieldName: string) => {
        newFormData[fieldName] = profile[fieldName as keyof TerminalProfileEntity];
    });

    // Copy nested objects – these are already flattened (dot-notation keys) on the profile entity
    Object.keys(profile).forEach((key) => {
        if (UPDATE_NESTED_FIELD_PREFIXES.some((prefix) => key.startsWith(prefix))) {
            newFormData[key] = profile[key as keyof TerminalProfileEntity];
        }
    });

    // Set readOnly visibility fields from terminal profile
    newFormData.serialProtocolCheckReadOnly = profile?.serialProtocolRO;
    newFormData.posIpAddressCheckReadOnly = profile?.posIpAddressRO;
    newFormData.posPortCheckReadOnly = profile?.posPortRO;
    newFormData.deviceApiTokenCheckReadOnly = profile?.deviceApiTokenRO;
    newFormData.abortNeedsRequestIdCheckReadOnly = profile?.abortNeedsRequestIdRO;
    newFormData.cloudFlowEnabledCheckReadOnly = profile?.cloudFlowEnabledRO;

    // Handle dynamic properties
    const dynamicPropertiesList = profile?.dynamicProperties?.dynamicPropertyValues || [];
    newFormData.dynamicProperties = {
        dynamicPropertyGroupValue: profile?.dynamicProperties?.dynamicPropertyGroupValue,
        dynamicPropertyValues: dynamicPropertiesList.map(({ id: _id, ...rest }) => {
            return {
                id: _id,
                ...rest,
            };
        }),
    };

    return newFormData;
};
